import styled from 'styled-components';

export const FullScreen = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    background: #fff;
    z-index: 301;
`;

export const HeaderBlock = styled.div`
    flex: 0 1 auto;
    width: 100%;
    height: calc(100vh * (51 / 812));
    min-height: calc(100vh * (51 / 812));
`;

export const ContentBlock = styled.div`
    flex: 1 1 auto;
    height: 100%;
    overflow-y: scroll;
`;